export const SET_INCIDENT_PROPERTIES = 'SET_INCIDENT_PROPERTIES';

export const setIncidentProperties = ({ propertyIds, flowBlockId }) => ({
  type: SET_INCIDENT_PROPERTIES,
  payload: {
    propertyIds,
    flowBlockId,
  },
});
